import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { IoCloseCircle, IoCopyOutline } from "react-icons/io5";
import { GoShield } from "react-icons/go";
import checkBackupCode from '../../services/CheckBackCode2f';

const BackupCode = ({ open, handleClose, handleVerify, userId }) => {
    const [backupCode, setBackupCode] = useState('');
    const [message, setMessage] = useState(null);
    const [newBackupModalOpen, setNewBackupModalOpen] = useState(false);
    const [newBackupCode, setNewBackupCode] = useState('');

    const handleSubmit = async () => {
        try {
            const resultados = await checkBackupCode({ backupCode, userId });
            if (resultados.success === 'success') {
                setNewBackupCode(resultados.backupnew);
                setNewBackupModalOpen(true);
                handleClose();
            } else {
                setMessage(resultados.message);
            }
        } catch (error) {
            setMessage('Error al obtener la información de la autenticación.');
        }
    };

    const handleNewBackupModalClose = () => {
        handleVerify();
        setNewBackupModalOpen(false);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };
    return (
        <>
            <Modal open={open} onClose={handleClose}>
                <Box className="modalBox">
                    <div className='modalHeader'>
                        <IconButton className="modalCloseButton" onClick={handleClose}>
                            <IoCloseCircle />
                        </IconButton>
                        <h2 className="modalHeader-title">Autenticación de dos Factores Activado</h2>
                    </div>
                    <div className='modalContent'>
                        <div className="modalDisclaimer">
                            <div className='modalDisclaimer-content'>
                                <GoShield className='modalDisclaimer-icon' />&nbsp;
                                Tu Código de Respaldo fue generado al finalizar la activación del 2FA en tu cuenta NEUBOX.
                            </div>
                        </div>
                        <div className="modalContent-input">
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                label="Código de respaldo"
                                value={backupCode}
                                onChange={(e) => setBackupCode(e.target.value)}
                                error={!!message}
                                helperText={message ? 'El código de respaldo proporcionado es inválido. Por favor, verifica que esté correcto.' : ''}
                            />
                        </div>
                        <div className="modalContent-button">
                            <Button
                                fullWidth
                                variant="contained"
                                className="modalButton tf-button btn-green"
                                onClick={handleSubmit}
                            >
                                Acceder
                            </Button>
                        </div>
                        <div className="modalContent-ayuda">
                            En caso de tener inconveniente con tu App y/o Código de Respaldo,
                            te pedimos comunicarte con nuestro equipo de Atención a Cliente al
                            <span>800 681 8136</span>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal open={newBackupModalOpen} onClose={handleNewBackupModalClose}>
                <Box className="modalBox">
                    <div className='modalHeader'>
                        <IconButton className="modalCloseButton" onClick={handleNewBackupModalClose}>
                            <IoCloseCircle />
                        </IconButton>
                        <h2 className="modalHeader-title">Autenticación de dos Factores Activado </h2>
                    </div>
                    <div className='modalContent'>
                        <div className="modalDisclaimer">
                            <div className='modalDisclaimer-content'>
                                <GoShield className='modalDisclaimer-icon' />&nbsp;
                                Se ha podido acceder mediante el código de respaldo. Los códigos de respaldo son válidos sólo una vez. Ahora será restablecido.
                            </div>
                        </div>  
                        <div className="modalBackup-content">
                            <h2 className="modalBackup-title">Tu Código de Respaldo es:</h2>
                            <div className='modalBackup-backup'>
                                {newBackupCode} &nbsp;
                                <span>
                                    <IoCopyOutline onClick={() => copyToClipboard(newBackupCode)}/>
                                </span>
                            </div>
                            <div className="modalBackup-txt">
                                Por favor,<span> guarda este Código de Respaldo en un lugar seguro y accesible solo por ti.</span><br></br>
                                Te recomendamos un gestor de contraseñas o alguna aplicación segura de notas privadas.<br></br><br></br>
                                Podrás utilizar este código para iniciar sesión <span>si no te es posible ingresar</span> a tu Aplicación de Autenticación desde tu dispositivo móvil.
                            </div>
                            <Button
                                fullWidth
                                variant="contained"
                                className="modalButton modalBackup-btn"
                                onClick={handleNewBackupModalClose}
                            >
                                Continuar
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default BackupCode;
